import { connect } from '../../../react-redux';
import TagSelect from './presenter';
import { bindActionCreators } from 'redux';
import { setTagInput, setTagSuggestions } from '../../../../common/actions/tagAssociations';
import { getTagSuggestions } from '../../../../banks/api/tagAssociations';
function mapStateToProps(state, props) {
  return {
    tagSuggestions: state.getIn(['tagAssociations', 'tagSuggestions', props.parentType, props.parentId])
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getTagSuggestions: bindActionCreators(getTagSuggestions, dispatch),
    setTagSuggestions: bindActionCreators(setTagSuggestions, dispatch),
    setTagInput: bindActionCreators(setTagInput, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TagSelect);